export abstract class ResendInviteStrategy {
  abstract resendInvite(): Promise<void>;
}
